import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";

import { useMe } from "@/api/hooks";
import { qk } from "@/api/keys";
import { FullScreenLoader } from "@/components/feedback/full-screen-loader";
import { UNAUTHORIZED_EVENT } from "@/lib/api";
import { AuthContext } from "@/state/auth";
import { useToast } from "@/state/toast";

export function RequireAuth() {
  const me = useMe();
  const location = useLocation();
  const queryClient = useQueryClient();
  const { toast } = useToast();

  useEffect(() => {
    const onUnauthorized = () => {
      if (queryClient.getQueryData(qk.me)) {
        toast("Tu sesión expiró. Vuelve a entrar.", "error");
        queryClient.setQueryData(qk.me, null);
      }
    };
    window.addEventListener(UNAUTHORIZED_EVENT, onUnauthorized);
    return () => window.removeEventListener(UNAUTHORIZED_EVENT, onUnauthorized);
  }, [queryClient, toast]);

  if (me.isPending) return <FullScreenLoader />;
  if (!me.data) {
    return <Navigate replace state={{ from: location.pathname + location.search }} to="/login" />;
  }
  return (
    <AuthContext value={me.data}>
      <Outlet />
    </AuthContext>
  );
}
